/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserRoleItem } from '../../models/user-role-item';

export interface UserRoleControllerDelete$Params {
  id: number;
}

export function userRoleControllerDelete(http: HttpClient, rootUrl: string, params: UserRoleControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>> {
  const rb = new RequestBuilder(rootUrl, userRoleControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserRoleItem;
      }>;
    })
  );
}

userRoleControllerDelete.PATH = '/user-role/{id}';
